import React from 'react';

/**
 * ErrorModal — מוצג כשיש שגיאה בחילוץ
 * @param {string} message - הודעת השגיאה
 * @param {function} onClose - סגירת המודל
 */
const ErrorModal = ({ message, onClose }) => {
  if (!message) return null;

  const is429 = message.includes('מכסת') || message.includes('429');

  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed', inset: 0, zIndex: 9999,
        background: 'rgba(0,0,0,0.55)',
        backdropFilter: 'blur(6px)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        padding: 24, direction: 'rtl',
      }}
    >
      <div
        onClick={e => e.stopPropagation()}
        style={{
          background: '#fff',
          borderRadius: 20,
          padding: '32px 28px',
          maxWidth: 360, width: '100%',
          boxShadow: '0 24px 64px rgba(0,0,0,0.18)',
          textAlign: 'center',
          animation: 'fadeUp 0.25s ease',
        }}
      >
        {/* Emoji */}
        <div style={{
          width: 68, height: 68, borderRadius: '50%',
          background: is429 ? '#fff7ed' : '#fef2f2',
          border: `2px solid ${is429 ? '#fed7aa' : '#fecaca'}`,
          margin: '0 auto 18px',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontSize: 32,
        }}>
          {is429 ? '⏳' : '😔'}
        </div>

        {/* Title */}
        <h2 style={{
          margin: '0 0 8px',
          fontSize: 18, fontWeight: 800,
          color: '#111827',
          fontFamily: 'system-ui, sans-serif',
        }}>
          {is429 ? 'מכסת השימוש הגיעה לסיומה' : 'אופס, קרתה תקלה'}
        </h2>

        {/* Subtitle */}
        <p style={{
          margin: '0 0 10px',
          fontSize: 14, color: '#6b7280',
          lineHeight: 1.6,
          fontFamily: 'system-ui, sans-serif',
        }}>
          {is429
            ? 'מצטערים! השגנו את המגבלה היומית של ה-AI. המערכת תתאפס בקרוב.'
            : 'מצטערים על הבעיה הטכנית. הצוות שלנו מודע לכך.'
          }
        </p>

        {/* Error message */}
        <div style={{
          background: '#f9fafb',
          border: '1px solid #e5e7eb',
          borderRadius: 10,
          padding: '10px 14px',
          marginBottom: 22,
          fontSize: 13, color: '#374151',
          fontFamily: 'monospace',
          textAlign: 'right',
        }}>
          {message}
        </div>

        {/* Retry tip */}
        <p style={{
          fontSize: 12, color: '#9ca3af',
          margin: '0 0 22px',
          fontFamily: 'system-ui, sans-serif',
        }}>
          💡 {is429 ? 'נסה שוב בעוד כמה דקות' : 'בדוק את החיבור לאינטרנט ונסה שוב'}
        </p>

        {/* Close button */}
        <button
          onClick={onClose}
          style={{
            width: '100%',
            padding: '13px 0',
            borderRadius: 12,
            background: is429 ? '#f97316' : '#ef4444',
            color: '#fff',
            fontWeight: 700, fontSize: 15,
            border: 'none', cursor: 'pointer',
            fontFamily: 'system-ui, sans-serif',
            boxShadow: `0 4px 14px ${is429 ? 'rgba(249,115,22,0.35)' : 'rgba(239,68,68,0.35)'}`,
            transition: 'opacity 0.15s',
          }}
          onMouseOver={e => e.target.style.opacity = 0.88}
          onMouseOut={e => e.target.style.opacity = 1}
        >
          הבנתי, אנסה שוב
        </button>
      </div>

      <style>{`
        @keyframes fadeUp {
          from { opacity: 0; transform: translateY(20px); }
          to   { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>
  );
};

export default ErrorModal;
